export default __webpack_public_path__ + "static/media/BlackPaper.61488ffc.svg";